import React from "react"
import { TouchableOpacity, View } from "react-native"
import styles from "./styles"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { RFValue } from "react-native-responsive-fontsize"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import CustomBorderedText from "@Components/CustomBorderedText"
import { randomColor } from "@Utils/utils"
import { arrayOfColors } from "@Constants/constant"
import { useNavigation } from "@react-navigation/core"

const CustomTopicItem = (props) => {
    const { item, topicCategory, setSelectedId } = props
    const color = randomColor(arrayOfColors)
    const navigation = useNavigation()
    const messages =
        item.subContent.messages > 0
            ? item.subContent.messages > 1
                ? `${item.subContent.messages} messages`
                : `${item.subContent.messages} message`
            : "Aucun message"

    const handlePress = () => {
        setSelectedId(item.id)
        navigation.navigate("TopicContent", { forumId: item.id, topicCategory: topicCategory })
    }

    return (
        <TouchableOpacity style={styles.container} onPress={handlePress}>
            <OpenSansText
                style={{ color: baseColors.black }}
                defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                fontSize={RFValue(14)}
            >
                {item.title}
            </OpenSansText>
            <View style={styles.child}>
                <CustomBorderedText label={topicCategory} color={color.textColor} backgroundColor={baseColors.white} />

                <CustomBorderedText label={messages} color={baseColors.green.dark} backgroundColor={baseColors.white} />
            </View>
        </TouchableOpacity>
    )
}

export default CustomTopicItem
